var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 9.452 10.262 c -0.981 0 -1.778 0.796 -1.778 1.778 s 0.796 1.778 1.778 1.778 c 0.981 0 1.778 -0.796 1.778 -1.778 s -0.796 -1.778 -1.778 -1.778 Z M 18.183 10.262 c -0.981 0 -1.778 0.796 -1.778 1.778 s 0.796 1.778 1.778 1.778 c 0.981 0 1.778 -0.796 1.778 -1.778 s -0.796 -1.778 -1.778 -1.778 Z M 16.889 20.444 c 0 0.98 -0.798 1.778 -1.778 1.778 s -1.778 -0.798 -1.778 -1.778 h 3.556 Z M 11.556 20.444 c 0 1.964 1.591 3.556 3.556 3.556 s 3.556 -1.591 3.556 -3.556 v -1.778 h -7.111 v 1.778 Z M 28.444 24 c 0 3.954 -2.592 6.222 -7.111 6.222 h -10.667 c -4.519 0 -7.111 -2.268 -7.111 -6.222 v -9.778 c 0 -6.862 5.582 -12.444 12.444 -12.444 s 12.444 5.582 12.444 12.444 v 9.778 Z M 16 0 c -7.854 0 -14.222 6.368 -14.222 14.222 v 9.778 c 0 4.908 3.285 8 8.889 8 h 10.667 c 5.604 0 8.889 -3.092 8.889 -8 v -9.778 c 0 -7.854 -6.368 -14.222 -14.222 -14.222 v 0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b5435008f6add88c0bf0ca45d7c5107c.svg";
export { ForwardRef as ReactComponent };